// extracted by mini-css-extract-plugin
module.exports = {"root":"header-wrapper_root__33kgA","container":"header-wrapper_container__oj2DG"};